import { render, staticRenderFns } from "./ShowApplicantDetailsButton.vue?vue&type=template&id=35b60d14&"
import script from "./ShowApplicantDetailsButton.vue?vue&type=script&lang=js&"
export * from "./ShowApplicantDetailsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports